module.exports = __webpack_public_path__ + "static/media/SC_iPad_Landscape.719ca5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SC_iPad_Landscape.png
// module id = 1103
// module chunks = 0